import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploadVedio from "../../../components/uploadVedio";
export default {
  components: {
    uploadVedio: uploadVedio
  },
  data: function data() {
    return {
      form: {
        id: "",
        name: "",
        pic: "",
        video: "",
        language: "",
        status: 1
      },
      iconfileList: [],
      picfileList: [],
      rules: {
        name: [{
          required: true,
          message: "请输入视频名称",
          trigger: "blur"
        }],
        pic: [{
          required: true,
          message: "请上传视频封面",
          trigger: "blur"
        }],
        video: [{
          required: true,
          message: "请上传视频",
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "blur"
        }]
      },
      gameTypeList: []
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$refs.newPopover.open();

                _this.$api.gameType().then(function (res) {
                  if (res.code == 0) {
                    _this.gameTypeList = res.data.list;
                  }
                });

                if (data) {
                  _this.$nextTick(function () {
                    _this.form = {
                      id: data.id,
                      name: data.name,
                      pic: data.pic,
                      language: data.language,
                      video: data.video,
                      icon: data.icon,
                      status: data.status
                    };

                    _this.$refs.picUploadImage.echos(data.pic);
                  });
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    picUrl: function picUrl(e) {
      this.picfileList = e;
      this.form.pic = e.toString();
    },
    // 视频
    getUrlVideo: function getUrlVideo(e) {
      this.form.video = e;
    },
    clearData: function clearData(id) {
      this.form = {
        id: id,
        name: "",
        pic: "",
        language: "",
        video: "",
        status: 1
      };
      this.$refs.picUploadImage.emptyFeil();
      this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = _this2.form.id ? 'updGameVideo' : 'addGameVideo';

          _this2.$api[reqFn](_this2.form).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.$refs.newPopover.hide();

              _this2.$emit('change');
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};